/* eslint-disable react/display-name */
import * as React from 'react';

const Spinner = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <g>
      <path d="M69.92,70.08a29,29,0,1,0-42.13-2.44,6,6,0,0,1-9.2,7.72A41,41,0,1,1,77,79.85l2,2.8a4.28,4.28,0,0,1-.94,6,4.44,4.44,0,0,1-1.81.75L54.83,92.93a4.27,4.27,0,0,1-4.49-6.17l10-19.32a4.26,4.26,0,0,1,5.75-1.82,4.18,4.18,0,0,1,1.49,1.28Z" />
    </g>
  </svg>
);

export default Spinner;
